import apiClient, { prefetchApiCsrfToken } from "../common";
import type { SimulationDeviationNoteCreateInput } from "views/admin/simulator/types/simulationDeviationNotes";

const JSON_API_MEDIA = "application/vnd.api+json";

/** PUT /api/v1/simulations/{id}/deviations/ — upsert bulk de motivos por período. */
export async function apiPutSimulationDeviations(
  simulationId: string,
  payloads: SimulationDeviationNoteCreateInput[],
): Promise<unknown> {
  await prefetchApiCsrfToken();
  const data = payloads.map((p) => {
    const attributes: Record<string, unknown> = {
      product_id: p.erpCode,
      deviation_note_id: Number.parseInt(p.deviationNoteId, 10),
      period_key: p.periodKey,
      period_index: p.periodIndex,
      is_actual: p.isActual ?? false,
      comments: p.comments ?? "",
    };
    if (p.periodStartDate) {
      attributes.period_start_date = p.periodStartDate;
    }
    const row: Record<string, unknown> = {
      type: "simulation-deviations",
      attributes,
    };
    if (p.simulationResultProductId) {
      row.relationships = {
        "simulation-result-product": {
          data: {
            type: "simulation-result-products",
            id: p.simulationResultProductId,
          },
        },
      };
    }
    return row;
  });

  const res = await apiClient.put(`simulations/${simulationId}/deviations/`, { data }, {
    headers: {
      Accept: JSON_API_MEDIA,
      "Content-Type": "application/json",
    },
  });
  return res.data;
}
